import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Input } from "antd";
import { Button, Modal } from "react-bootstrap";
import { MotorPattern } from "../../types/Entities";
import { useEffect } from "react";
import { TailSpin } from "react-loader-spinner";

type Props = {
  motorPattern?: MotorPattern;
  onSubmit?: (values: any) => void;
  onClose?: () => void;
  loading: boolean;
};

export default function MotorPatternForm({
  onSubmit,
  onClose,
  motorPattern,
  loading,
}: Props) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (motorPattern)
      form.setFieldValue("motorPattern", motorPattern.motorPattern);
  }, [motorPattern, form]);

  return (
    <Form form={form} onFinish={onSubmit}>
      <Modal.Body>
        <Form.Item
          name="motorPattern"
          label="Nome Pattern"
          rules={[
            {
              required: true,
              message: "Il nome del Pattern Motorio è obbligatorio",
            },
          ]}
        >
          <Input placeholder="Nome Pattern..." />
        </Form.Item>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button
          variant="light"
          size="sm"
          className="border"
          onClick={onClose}
          disabled={loading}
        >
          {loading ? (
            <TailSpin width={15} height={15} color="#9c1419" />
          ) : (
            <span>Chiudi</span>
          )}
        </Button>
        <Button type="submit" variant="success" size="sm" disabled={loading}>
          {loading ? (
            <TailSpin width={15} height={15} color="#9c1419" />
          ) : (
            <>
              <FontAwesomeIcon icon={faSave} />
              <span className="ms-2">Salva</span>
            </>
          )}
        </Button>
      </Modal.Footer>
    </Form>
  );
}
